import { c as _c } from "react/compiler-runtime";
import type { UserTimelineEventExternalIntegrationCalled } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
type ExternalIntegrationCalledEventHeaderProps = {
  data: UserTimelineEventExternalIntegrationCalled['data'];
};
const ExternalIntegrationCalledEventHeader = t0 => {
  const $0 = _c(11);
  const {
    data
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.externalIntegrationCalled"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($0[1] !== data) {
    t2 = $ => $[data.successful ? "true" : "false"];
    $0[1] = data;
    $0[2] = t2;
  } else {
    t2 = $0[2];
  }
  let t3;
  if ($0[3] !== data) {
    t3 = $_0 => $_0[data.integration];
    $0[3] = data;
    $0[4] = t3;
  } else {
    t3 = $0[4];
  }
  let t4;
  if ($0[5] !== t || $0[6] !== t2 || $0[7] !== t3) {
    t4 = t(t2, {
      kind: t(t3)
    });
    $0[5] = t;
    $0[6] = t2;
    $0[7] = t3;
    $0[8] = t4;
  } else {
    t4 = $0[8];
  }
  let t5;
  if ($0[9] !== t4) {
    t5 = <p className="text-body-2">{t4}</p>;
    $0[9] = t4;
    $0[10] = t5;
  } else {
    t5 = $0[10];
  }
  return t5;
};
export default ExternalIntegrationCalledEventHeader;